module.exports = __webpack_public_path__ + "img/工作真实性-文字信息@2x.f4ed35c4.png";